<div [ngClass]="{'visible': alertService.isVisible}" class="modal" [id]="alertService.ALERT_MODAL_ID">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <p [innerHTML]="alertService.message$ |async "></p>
                <button (click)="onCancel()"
                        class="btn btn-round {{ (alertService.inverted$ | async) ? 'btn-primary': 'btn-danger'}}" title="Schließen">{{ alertService.btnCancel$ |async }}
                </button>
                <button (click)="onApprove()"
                        class="btn btn-link {{ (alertService.inverted$ | async) ? 'text-danger': 'text-primary'}}">{{ alertService.btnApprove$ |async }}
                </button>
            </div>
        </div>
    </div>
</div>
